import { render } from "./TheHeader.vue?vue&type=template&id=5bb79cf2&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=5bb79cf2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bb79cf2"
/* hot reload */
if (module.hot) {
  script.__hmrId = "5bb79cf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bb79cf2', script)) {
    api.reload('5bb79cf2', script)
  }
  
  module.hot.accept("./TheHeader.vue?vue&type=template&id=5bb79cf2&scoped=true", () => {
    api.rerender('5bb79cf2', render)
  })

}

script.__file = "src/layout/TheHeader.vue"

export default script